export default __webpack_public_path__ + "static/media/clock.db2a5dfc.svg";